import { useEffect } from 'react';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function CachaloYGanaPortfolio() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans selection:bg-gray-200 selection:text-black">
      <title>Cachalo y Gana | Gamificación y Lealtad | Mood Agency</title>
      <meta name="description" content="Caso de éxito Cachalo y Gana: Desarrollo de una plataforma de fidelización y gamificación." />
      
      <Navbar />
      
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden bg-white">
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
          <div className="absolute w-[60vw] h-[60vw] bg-[radial-gradient(circle,var(--tw-gradient-stops))] from-blue-100 via-gray-100/50 to-transparent rounded-full blur-[80px] opacity-100 z-0"></div>
          <div className="w-[90vw] h-[90vw] border border-gray-200 rounded-full absolute opacity-40"></div>
          <div className="w-[70vw] h-[70vw] border border-gray-300 rounded-full absolute opacity-50"></div>
          <div className="w-[50vw] h-[50vw] border border-gray-300 rounded-full absolute opacity-60"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-6 text-center">
          <div className="mb-8 animate-fade-in-up">
            <span className="font-display text-[10px] tracking-[0.4em] text-gray-400 uppercase">
              CASO DE ÉXITO
            </span>
          </div>
          
          <h1 className="font-display text-[12vw] md:text-[8vw] leading-none font-bold uppercase tracking-tighter text-gray-900 mb-8 animate-fade-in-up delay-100">
            Cachalo y Gana
          </h1>
          
          <p className="max-w-3xl mx-auto font-sans text-xl text-gray-500 font-light leading-relaxed animate-fade-in-up delay-200">
            Desafío en vivo: conectando con audiencias masivas a través de la velocidad y la gamificación.
          </p>
        </div>
      </section>

      {/* Key Metrics */}
      <section className="py-20 px-6 bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">100%</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Estabilidad del Sitio</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">CMS</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">WordPress Optimizado</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">Live</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Tracking de Audiencia</p>
          </div>
        </div>
      </section>

      {/* The Context */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mb-12 uppercase">El Contexto</h2>
          <p className="font-sans text-xl md:text-2xl text-gray-500 leading-relaxed font-light">
            Cachalo y Gana fue un programa de concursos en vivo donde la audiencia participaba en tiempo real. El proyecto necesitaba un centro digital robusto que sirviera como puente entre el programa en vivo y los miles de usuarios que accedían simultáneamente para interactuar con la dinámica.
          </p>
        </div>
      </section>

      {/* The Challenge */}
      <section className="py-32 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-20 items-center">
          <div>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 mb-8 uppercase leading-tight">
              Desafío<br/>Web
            </h2>
            <p className="font-sans text-lg text-gray-500 leading-relaxed mb-12">
              Nuestro reto fue desarrollar una plataforma web en WordPress que fuera extremadamente fácil de administrar y capaz de soportar picos masivos de tráfico. El sitio debía integrar video y herramientas de rastreo sin comprometer la velocidad ni la experiencia del usuario.
            </p>
          </div>
          <div className="space-y-12">
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Gestión de Contenido</h3>
              <p className="font-sans text-gray-500">Implementación de un panel administrativo intuitivo para actualizaciones rápidas durante las transmisiones.</p>
            </div>
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Picos de Tráfico</h3>
              <p className="font-sans text-gray-500">Preparación de la infraestructura para recibir a miles de usuarios al mismo tiempo durante los 15 segundos de votación.</p>
            </div>
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Integración de Video</h3>
              <p className="font-sans text-gray-500">Optimización del sitio para asegurar que el despliegue de video fuera fluido y estable para toda la audiencia.</p>
            </div>
          </div>
        </div>
      </section>

      {/* The Solution */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="mb-20">
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 uppercase">La Solución</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-px bg-gray-200 border border-gray-200">
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">WordPress & UI TikTok</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Desarrollamos el sitio bajo WordPress con un diseño inspirado en TikTok, facilitando la navegación y logrando una conexión orgánica con la audiencia del juego.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Infraestructura Cloudflare</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Configuramos Cloudflare para garantizar la estabilidad absoluta del sitio y una entrega de contenido eficiente incluso en momentos de máxima concurrencia.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Tracking Avanzado</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Integramos Google Analytics para obtener un seguimiento detallado del comportamiento de los usuarios en el sitio durante los eventos en vivo.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Impact */}
      <section className="py-32 px-6 bg-black text-white">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-20 uppercase tracking-widest">Resultado</h2>
          
          <div className="max-w-4xl mx-auto">
            <p className="font-display text-2xl md:text-4xl leading-tight mb-12">
              "Entregamos una plataforma web robusta y visualmente atractiva que permitió al programa Cachalo y Gana operar con total estabilidad y facilidad administrativa."
            </p>
            <div className="w-20 h-1 bg-white mx-auto opacity-30"></div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
